import React, { useContext, useEffect, useState } from "react";
import LanguageContext from "../LanguageContext";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import HelpCTAButton from "./HelpCTAButton";

export default function HelpCTA(props) {
  let { timerInSeconds, page, userState, mobile, helpText, section } = props;
  const language = useContext(LanguageContext);
  const [timer, setTimer] = useState("00:00");
  const [disabledCTA, toggleDisabledCTA] = useState(false);

  const startTimer = function (timeInSeconds) {
    let interval = setInterval(() => {
      let minutes = Math.floor(timeInSeconds / 60);
      let seconds = Math.floor(timeInSeconds % 60);
      let minutesString = minutes;
      let secondsString = seconds;
      if (Math.floor(minutes / 10) === 0) {
        minutesString = `0${minutes}`;
      }
      if (Math.floor(seconds / 10) === 0) {
        secondsString = `0${seconds}`;
      }
      setTimer(`${minutesString}:${secondsString}`);
      timeInSeconds--;
      if (timeInSeconds === 0) {
        clearInterval(interval);
        toggleDisabledCTA(false);
      }
    }, 1000);
  };

  useEffect(() => {
    if (timerInSeconds) {
      toggleDisabledCTA(true);
      startTimer(timerInSeconds);
    }
  }, [timerInSeconds]);
  return (
    <LanguageContext.Provider value={language}>
      <Grid container direction="column" alignItems="center">
        <Typography variant="subtitle2" gutterBottom>
          {helpText}
        </Typography>

        <HelpCTAButton
          userState={userState}
          mobile={mobile}
          page={page}
          section={section}
          userType={props.userType}
        />

        {disabledCTA && (
          <Typography
            variant="caption"
            gutterBottom
            style={{ marginTop: "8px" }}
          >
            {timer}
          </Typography>
        )}
      </Grid>
    </LanguageContext.Provider>
  );
}
